import { Box, Stack } from '@mui/material'

import FeedTableIcon from 'assets/FeedTableIcon'
import { roundingNumber } from 'components/shared/processes'
import { BaseWidget } from 'components/farm-dashboard/components/widgets/baseWidget'
import { useWidgetStatistics } from 'components/farm-dashboard/hooks/useWidgetStatistics'
import { useAppSelector } from 'store/hooks'
import { COLORS } from 'styles/colors'
import { TypographyPrimary } from 'ui/typography/TypographyPrimary'
import { TypographyPrimary16Bold } from 'ui/typography/TypographyPrimary16Bold'
import { TypographySecondary } from 'ui/typography/TypographySecondary'

export const PsvAvgDry = () => {
	const { permissions } = useAppSelector(state => state.authReducer)
	const { statistics, loading, error } = useWidgetStatistics()

	if (!permissions?.license_food_table || error) return null

	const psvDryCows = statistics?.psv_dry_cows?.count

	return (
		<BaseWidget
			icon={
				<Box
					sx={{
						width: '24px',
						height: '24px',
						backgroundColor: COLORS.mainSecondaryOpacity,
						borderRadius: '50%',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
					}}
				>
					<FeedTableIcon color={COLORS.main} width={16} height={16} />
				</Box>
			}
			path={'/feed/'}
			isLoading={loading}
		>
			<Stack direction='column' gap='8px'>
				<Stack direction='row' gap='4px' alignItems='center'>
					{(psvDryCows || psvDryCows === 0) && (
						<TypographyPrimary16Bold>
							{roundingNumber(psvDryCows, 1).toLocaleString()}
						</TypographyPrimary16Bold>
					)}
					<TypographySecondary>кг/гол</TypographySecondary>
				</Stack>
				<TypographyPrimary>Среднее ПСВ сухойстойных голов</TypographyPrimary>
			</Stack>
		</BaseWidget>
	)
}
